import ErrorWidget from './error.widget';
export default ErrorWidget;
